import menus from 'netxcore@netx/core-cms/menus';
import Menu from '@netx/core/lib/netx-menu';

// New menus
Object.assign(menus, {
	/**
	 * Mobile actions menu
	 * @menu
	 */
	mobilePageMenu: new Menu({
		actions: [
			'cms:page:home:route',
			'cms:route:category:root',
			'cms:cart:route',
			'cms:saved-carts:route',
		],
	}),
});

export default menus;
